module.exports = __webpack_public_path__ + "img/ic_grade_Diamond.bc0232d.png";